var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigBagsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#15171B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4841 33.5361C83.4841 32.0686 82.2945 30.8791 80.8271 30.8791H39.1718C37.7043 30.8791 36.5146 32.0686 36.5146 33.5361C36.5146 34.2408 36.7946 34.9165 37.2929 35.4148C37.9976 36.1195 38.3935 37.0753 38.3935 38.0719V81.9284C38.3935 82.4218 38.2963 82.9105 38.1075 83.3663C37.9186 83.8222 37.6418 84.2365 37.2929 84.5854C36.7946 85.0836 36.5147 85.7594 36.5146 86.4641C36.5146 87.9315 37.7043 89.1211 39.1718 89.1211H80.8271C82.2945 89.1211 83.4841 87.9315 83.4841 86.4641C83.4841 85.7595 83.2041 85.0836 82.7058 84.5854C82.0012 83.8807 81.6053 82.9249 81.6053 81.9284V38.0719C81.6053 37.0753 82.0012 36.1196 82.7058 35.4148C82.9526 35.1681 83.1483 34.8752 83.2818 34.5528C83.4154 34.2305 83.4841 33.885 83.4841 33.5361Z",
    stroke: "#FFA500FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.999 75.9697V55.3886",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.291 51.5456C58.291 53.0422 58.9436 54.3974 59.999 55.3885C61.0544 54.3974 61.7069 53.0422 61.7069 51.5456C61.7069 50.049 61.0544 48.6938 59.999 47.7027C58.9436 48.6938 58.291 50.049 58.291 51.5456Z",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6834 61.4125C56.8463 62.5754 58.4061 63.1212 59.9962 63.0713C60.0462 61.4812 59.5003 59.9212 58.3375 58.7585C57.1747 57.5956 55.6147 57.0498 54.0246 57.0997C53.9747 58.6897 54.5206 60.2497 55.6834 61.4125Z",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3091 61.4125C63.1463 62.5754 61.5864 63.1212 59.9963 63.0713C59.9464 61.4812 60.4922 59.9212 61.6551 58.7585C62.8178 57.5956 64.3778 57.0498 65.9679 57.0997C66.0178 58.6897 65.472 60.2497 64.3091 61.4125Z",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0665 69.7148C56.3956 71.0439 58.1786 71.6678 59.996 71.6107C60.0531 69.7933 59.4292 68.0103 58.1001 66.6813C56.771 65.3521 54.988 64.7282 53.1706 64.7853C53.1135 66.6026 53.7374 68.3857 55.0665 69.7148Z",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9262 69.7148C63.5971 71.0439 61.8141 71.6678 59.9967 71.6107C59.9397 69.7933 60.5636 68.0103 61.8926 66.6813C63.2217 65.3521 65.0047 64.7282 66.8222 64.7853C66.8793 66.6026 66.2552 68.3857 64.9262 69.7148Z",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8782 47.4642C63.6104 42.5134 54.4934 42.9216 48.7072 48.7078C42.9209 54.494 42.5128 63.611 47.4636 69.8788",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1201 72.5359C56.388 77.4867 65.5049 77.0786 71.2911 71.2923C77.0775 65.5061 77.4855 56.3892 72.5347 50.1213",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1514 85.3635H77.8481",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1514 34.6367H77.8481",
    stroke: "#FFA500",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBagsImg);
export default __webpack_public_path__ + "static/media/bigBagsImg.98aa10c820e22ecfc865769787a3db06.svg";
export { ForwardRef as ReactComponent };